/* MoRetro Studio V5 — App / Dashboard */
window.MTS = window.MTS || {};

(function(MTS){
  "use strict";

  const QUOTE_SIMULATIONS_KEY = "moretroQuoteSimulations";
  let selectedQuoteId = "";
  function quoteAmount(project){return Number(project.quote?.total||project.autoQuote?.quote?.suggested||0);}
  function quoteDate(project){const ms=MTS.millis(project.quote?.updatedAt||project.quote?.createdAt||project.updatedAt||project.createdAt);return ms?new Date(ms).toLocaleString("fr-FR"):"Date inconnue";}
  function simulations(){try{return JSON.parse(localStorage.getItem(QUOTE_SIMULATIONS_KEY)||"[]");}catch(e){return [];}}
  function calculatorValues(){const n=id=>Math.max(0,Number(MTS.$(id)?.value||0));return{name:(MTS.$("mtsCalcName")?.value||"Projet sans nom").trim()||"Projet sans nom",weight:n("mtsCalcWeight"),materialRate:n("mtsCalcMaterialRate"),printHours:n("mtsCalcPrintHours"),machineRate:n("mtsCalcMachineRate"),laborHours:n("mtsCalcLaborHours"),laborRate:n("mtsCalcLaborRate"),consumables:n("mtsCalcConsumables"),failure:Math.min(100,n("mtsCalcFailure")),margin:Math.min(95,n("mtsCalcMargin")),vat:Math.min(100,n("mtsCalcVat"))};}
  function calculateSimulation(v=calculatorValues()){const material=v.weight/1000*v.materialRate,machine=v.printHours*v.machineRate,labor=v.laborHours*v.laborRate,direct=material+machine+labor+v.consumables,risk=direct*v.failure/100,cost=direct+risk,exVat=cost/(1-v.margin/100),vatAmount=exVat*v.vat/100;return{...v,material,machine,labor,direct,risk,cost,exVat,vatAmount,total:exVat+vatAmount};}
  function renderCalculation(){const c=calculateSimulation();MTS.html("mtsQuoteCalculation",`<article><span>Matière</span><strong>${MTS.money(c.material)}</strong></article><article><span>Machine</span><strong>${MTS.money(c.machine)}</strong></article><article><span>Main-d'œuvre</span><strong>${MTS.money(c.labor)}</strong></article><article><span>Coût + risque</span><strong>${MTS.money(c.cost)}</strong></article><article><span>Prix conseillé TTC</span><strong>${MTS.money(c.total)}</strong></article>`);return c;}
  function renderSimulations(){const list=simulations();MTS.html("mtsQuoteSimulations",list.length?list.map(s=>`<div class="mts-product-item"><strong>${MTS.escapeHtml(s.name)}</strong><span>${MTS.money(s.total)} — ${MTS.escapeHtml(new Date(s.savedAt).toLocaleString("fr-FR"))}</span><button type="button" class="mts-btn" data-simulation-delete="${MTS.escapeHtml(s.id)}">Supprimer</button></div>`).join(""):'<div class="mts-empty">Aucune simulation sauvegardée.</div>');}
  function renderQuoteDetail(){const p=MTS.state.projects.find(item=>item.id===selectedQuoteId);if(!p){MTS.html("mtsQuoteDetail",'<div class="mts-empty">Sélectionne un devis pour revoir son détail.</div>');return;}const q=p.quote||p.autoQuote?.quote||{},note=q.note||q.message||p.message||"Aucune note enregistrée.";MTS.html("mtsQuoteDetail",`<div class="mts-detail-head"><div><h3>${MTS.escapeHtml(p.projectType||"Projet")}</h3><p>${MTS.escapeHtml(p.name||"Client")}</p></div></div><div class="mts-quote-total-card"><span>Montant du devis</span><strong>${MTS.money(quoteAmount(p))}</strong></div><div class="mts-quote-detail-lines"><div><span>Client</span><strong>${MTS.escapeHtml(p.name||"Client")}</strong></div><div><span>Email</span><strong>${MTS.escapeHtml(p.email||"Non renseigné")}</strong></div><div><span>Créé / modifié</span><strong>${MTS.escapeHtml(quoteDate(p))}</strong></div><div><span>Statut</span><strong>${MTS.escapeHtml(MTS.statusLabel(p.status))}</strong></div></div><div class="mts-detail-box"><strong>Informations du projet</strong><p>${MTS.escapeHtml(note)}</p></div><div class="mts-actions"><button type="button" class="mts-btn mts-btn-primary" data-quote-open-project="${MTS.escapeHtml(p.id)}">Ouvrir le projet original</button></div>`);}

  function calcData(){
    const rated = MTS.state.reviews.filter(r=>Number(r.rating||0)>0);
    const avg = rated.length ? rated.reduce((s,r)=>s+Number(r.rating||0),0)/rated.length : 0;
    const clients = {};

    MTS.state.projects.forEach(p=>{
      const email = (p.email || "").toLowerCase();
      if(email) clients[email] = true;
    });

    const quoteProjects = MTS.state.projects.filter(p=>p.quote || p.autoQuote);
    const quoteTotal = quoteProjects.reduce((s,p)=>s+Number((p.quote&&p.quote.total)||(p.autoQuote&&p.autoQuote.quote&&p.autoQuote.quote.suggested)||0),0);
    const prodStatuses = ["paid","printing","finishing","ready"];

    return {
      rated,
      avg,
      pendingReviews:MTS.state.reviews.filter(r=>r.status==="pending").length,
      newProjects:MTS.state.projects.filter(p=>(p.status||"new")==="new").length,
      quoteCount:quoteProjects.length,
      quoteTotal,
      prodCount:MTS.state.projects.filter(p=>prodStatuses.includes(p.status)).length,
      clientCount:Object.keys(clients).length
    };
  }

  function updateStats(){
    const d = calcData();
    const projectsBadge = MTS.$("mtsProjectsNavCount");

    MTS.text("mtsRequestsCount", MTS.state.projects.length);
    MTS.text("mtsRequestsNew", d.newProjects + " nouvelle(s)");
    if(projectsBadge){
      projectsBadge.textContent = String(d.newProjects);
      projectsBadge.hidden = d.newProjects === 0;
    }
    MTS.text("mtsQuotesCount", d.quoteCount);
    MTS.text("mtsQuotesTotal", MTS.money(d.quoteTotal) + " estimés");
    MTS.text("mtsProductionCount", d.prodCount);
    MTS.text("mtsPending", d.pendingReviews);
    MTS.text("mtsAvg", d.rated.length ? d.avg.toFixed(1).replace(".", ",") : "—");
    MTS.text("mtsAvgStars", d.rated.length ? MTS.stars(Math.round(d.avg)) : "★★★★★");
    MTS.text("mtsClientsCount", d.clientCount);
  }

  function renderDashboard(){
    const latest = [...MTS.state.projects].sort((a,b)=>MTS.millis(b.createdAt)-MTS.millis(a.createdAt)).slice(0,5);

    MTS.html("mtsLatestRequests", latest.length ? latest.map(p=>`
      <div class="mts-mini-item">
        <strong>${MTS.escapeHtml(p.projectType||"Projet")}</strong>
        <span>${MTS.escapeHtml(p.name||"Client")} — ${MTS.escapeHtml(MTS.statusLabel(p.status))}<br>${MTS.escapeHtml((p.message||"").slice(0,90))}</span>
      </div>
    `).join("") : '<div class="mts-empty">Aucune demande.</div>');

    const prod = MTS.state.projects.filter(p=>["paid","printing","finishing","ready"].includes(p.status)).slice(0,5);

    MTS.html("mtsProductionMini", prod.length ? prod.map(p=>`
      <div class="mts-mini-item">
        <strong>${MTS.escapeHtml(p.projectType||"Projet")}</strong>
        <span>${MTS.escapeHtml(p.name||"Client")} — ${MTS.escapeHtml(MTS.statusLabel(p.status))}</span>
      </div>
    `).join("") : '<div class="mts-empty">Aucune production en cours.</div>');
  }

  function renderQuotes(){
    const search=(MTS.$("mtsQuoteSearch")?.value||"").trim().toLowerCase();
    const quoted=MTS.state.projects.filter(p=>p.quote||p.autoQuote).filter(p=>!search||[p.name,p.email,p.projectType,p.message].join(" ").toLowerCase().includes(search)).sort((a,b)=>MTS.millis(b.updatedAt)-MTS.millis(a.updatedAt));

    MTS.html("mtsQuotesList", quoted.length ? quoted.map(p=>`
      <div class="mts-product-item ${selectedQuoteId===p.id?"active":""}" data-quote-project="${MTS.escapeHtml(p.id)}">
        <strong>${MTS.escapeHtml(p.name||"Client")} — ${MTS.escapeHtml(p.projectType||"Projet")}</strong>
        <span>${MTS.money(quoteAmount(p))} — ${MTS.escapeHtml(p.email||"")} — ${MTS.escapeHtml(quoteDate(p))}</span>
      </div>
    `).join("") : '<div class="mts-empty">Aucun devis généré.</div>');
    if(selectedQuoteId&&!quoted.some(p=>p.id===selectedQuoteId))selectedQuoteId="";
    renderQuoteDetail();renderSimulations();
  }

  function bindQuotes(){
    MTS.on("mtsQuoteSearch","input",renderQuotes);
    MTS.on("mtsQuoteSimulatorToggle","click",()=>{MTS.$("mtsQuoteSimulator").hidden=false;renderCalculation();});
    MTS.on("mtsQuoteSimulatorClose","click",()=>{MTS.$("mtsQuoteSimulator").hidden=true;});
    document.querySelectorAll("#mtsQuoteSimulator input").forEach(input=>input.addEventListener("input",renderCalculation));
    MTS.on("mtsQuoteSimulationSave","click",()=>{const c=renderCalculation(),list=simulations();list.unshift({...c,id:"sim-"+Date.now(),savedAt:new Date().toISOString()});localStorage.setItem(QUOTE_SIMULATIONS_KEY,JSON.stringify(list.slice(0,50)));renderSimulations();});
    MTS.$("mtsPanelQuotes")?.addEventListener("click",event=>{const quote=event.target.closest("[data-quote-project]");if(quote){selectedQuoteId=quote.dataset.quoteProject;renderQuotes();return;}const open=event.target.closest("[data-quote-open-project]");if(open){MTS.state.selectedProjectId=open.dataset.quoteOpenProject;document.querySelector('.mts-nav button[data-panel="projects"]')?.click();MTS.Projects.renderList();return;}const remove=event.target.closest("[data-simulation-delete]");if(remove){localStorage.setItem(QUOTE_SIMULATIONS_KEY,JSON.stringify(simulations().filter(s=>s.id!==remove.dataset.simulationDelete)));renderSimulations();}});
  }

  function renderClients(){
    const clients = {};

    MTS.state.projects.forEach(p=>{
      const email = (p.email || "").toLowerCase() || "sans-email";

      if(!clients[email]){
        clients[email] = {email, name:p.name||"Client", count:0, total:0, last:0};
      }

      clients[email].count++;
      clients[email].total += Number((p.quote&&p.quote.total)||(p.autoQuote&&p.autoQuote.quote&&p.autoQuote.quote.suggested)||0);
      clients[email].last = Math.max(clients[email].last, MTS.millis(p.createdAt));
    });

    const arr = Object.values(clients).sort((a,b)=>b.last-a.last);

    MTS.html("mtsClientsList", arr.length ? arr.map(c=>`
      <div class="mts-product-item">
        <strong>${MTS.escapeHtml(c.name)}</strong>
        <span>${MTS.escapeHtml(c.email)} — ${c.count} projet(s) — ${MTS.money(c.total)}</span>
      </div>
    `).join("") : '<div class="mts-empty">Aucun client.</div>');
  }

  function renderProduction(){
    const columns = [
      ["paid","Payé"],
      ["printing","En impression"],
      ["finishing","Finition"],
      ["ready","Prêt à expédier"],
      ["shipped","Expédié"]
    ];

    MTS.html("mtsProductionKanban", columns.map(([st,label])=>{
      const items = MTS.state.projects.filter(p=>p.status===st);

      return `
        <div class="mts-kanban-col">
          <h4>${label}</h4>
          ${items.length ? items.map(p=>`
            <div class="mts-kanban-card">
              <strong>${MTS.escapeHtml(p.projectType||"Projet")}</strong>
              <span>${MTS.escapeHtml(p.name||"Client")}<br>${MTS.escapeHtml(p.email||"")}</span>
            </div>
          `).join("") : '<div class="mts-empty">Vide</div>'}
        </div>
      `;
    }).join(""));

    if(MTS.Workshop && typeof MTS.Workshop.render === "function"){
      MTS.Workshop.render();
    }
  }

  function renderShipping(){
    const items = MTS.state.projects.filter(p=>["ready","shipped"].includes(p.status));

    MTS.html("mtsShippingList", items.length ? items.map(p=>`
      <div class="mts-product-item">
        <strong>${MTS.escapeHtml(p.projectType||"Projet")}</strong>
        <span>${MTS.escapeHtml(p.name||"Client")} — ${MTS.escapeHtml(MTS.statusLabel(p.status))}<br>Sendcloud sera branché via backend.</span>
      </div>
    `).join("") : '<div class="mts-empty">Aucun colis prêt.</div>');
  }

  function renderLibrary(){
    const items = MTS.state.projects.filter(p=>p.status==="done");

    MTS.html("mtsLibraryList", items.length ? items.map(p=>`
      <div class="mts-product-item">
        <strong>${MTS.escapeHtml(p.projectType||"Projet terminé")}</strong>
        <span>${MTS.escapeHtml(p.name||"Client")} — ${MTS.money((p.quote&&p.quote.total)||(p.autoQuote&&p.autoQuote.quote&&p.autoQuote.quote.suggested)||0)}</span>
      </div>
    `).join("") : '<div class="mts-empty">Les projets terminés apparaîtront ici.</div>');
  }

  function renderAll(){
    updateStats();
    renderDashboard();
    if(MTS.Orders && typeof MTS.Orders.updateDashboardRevenue === "function") MTS.Orders.updateDashboardRevenue();
    MTS.Projects.renderList();
    renderQuotes();
    if(MTS.ClientsShopify) MTS.ClientsShopify.render();
    else renderClients();
    renderProduction();
    renderShipping();
    renderLibrary();
    MTS.Reviews.render();
    if(MTS.Support) MTS.Support.render();
  }

  function bindNavigation(){
    document.querySelectorAll(".mts-nav button").forEach(btn=>{
      btn.addEventListener("click",()=>{
        document.querySelectorAll(".mts-nav button").forEach(b=>b.classList.remove("active"));
        document.querySelectorAll(".mts-panel").forEach(p=>p.classList.remove("active"));

        btn.classList.add("active");

        const panel = btn.dataset.panel || "dashboard";
        const target = MTS.$("mtsPanel" + panel.charAt(0).toUpperCase() + panel.slice(1));

        if(target) target.classList.add("active");
      });
    });

    document.querySelectorAll("[data-jump]").forEach(btn=>{
      btn.addEventListener("click",()=>{
        document.querySelector(`.mts-nav button[data-panel="${btn.dataset.jump}"]`)?.click();
      });
    });
  }

  function bindProjectFilters(){
    ["mtsProjectSearch","mtsProjectStatus","mtsProjectSort"].forEach(id=>{
      const el = MTS.$(id);
      if(el) el.addEventListener(id==="mtsProjectSearch" ? "input" : "change", MTS.Projects.renderList);
    });

    const pList = MTS.$("mtsProjectList");
    if(pList){
      pList.addEventListener("click",e=>{
        const btn = e.target.closest("[data-project-id]");
        if(!btn) return;
        MTS.state.selectedProjectId = btn.dataset.projectId;
        MTS.Projects.renderList();
      });
    }
  }

  async function start(){
    MTS.on("mtsGoogleLogin","click",MTS.googleLogin);
    MTS.on("mtsLogout","click",()=>MTS.state.auth && MTS.state.auth.signOut());
    MTS.on("mtsRefresh","click",()=>{
      renderAll();
      if(MTS.Support) MTS.Support.load(true);
    });

    bindNavigation();
    bindProjectFilters();
    bindQuotes();
    MTS.Reviews.bind();

    try{
      await MTS.initFirebase();

      MTS.state.auth.onAuthStateChanged(async user=>{
        if(MTS.isAdmin(user)){
          MTS.showApp(user);
        }else{
          if(user){
            MTS.setError("Accès refusé.");
            await MTS.state.auth.signOut();
          }
          MTS.showLogin();
        }
      });
    }catch(err){
      console.error(err);
      MTS.setError("Erreur Firebase. Vérifie la connexion et les scripts.");
      MTS.showLogin();
    }
  }

  MTS.App = {
    start,
    renderAll,
    updateStats,
    renderDashboard,
    renderQuotes,
    renderClients,
    renderProduction,
    renderShipping,
    renderLibrary
  };

  document.addEventListener("DOMContentLoaded", start);

})(window.MTS);

/* V27.8 - Shopify customers merged with custom-project customers. */
(function(MTS){
  "use strict";

  const API_BASE = "https://bubbly-vibrancy-production.up.railway.app";
  let loaded = false;
  let loading = false;
  let clientsList = [];
  let selectedClientKey = "";
  let saving = false;
  let loadError = "";

  function projectDate(value){
    try{
      if(value?.toMillis) return value.toMillis();
      if(value?.toDate) return value.toDate().getTime();
      return Date.parse(value || "") || 0;
    }catch(e){
      return 0;
    }
  }

  function money(value, currency = "EUR"){
    try{
      return new Intl.NumberFormat("fr-FR", {style:"currency", currency}).format(Number(value || 0));
    }catch(e){
      return MTS.money(value);
    }
  }

  function render(){
    const clients = {};

    (MTS.state.shopifyCustomers || []).forEach(customer=>{
      const email = String(customer.email || "").trim().toLowerCase();
      const customerId = String(customer.id || "");
      const mergeKey = email || `shopify:${customerId}`;
      clients[mergeKey] = {
        id:customer.id || "",
        key:`shopify:${customerId || email}`,
        email,
        name:customer.name || "Client Shopify",
        phone:customer.phone || "",
        orderCount:Number(customer.numberOfOrders || 0),
        projectCount:0,
        total:Number(customer.amountSpent || 0),
        currency:customer.currency || "EUR",
        last:Date.parse(customer.updatedAt || customer.createdAt || "") || 0,
        shopify:true,
        verifiedEmail:!!customer.verifiedEmail,
        marketingState:String(customer.emailMarketingState || "").toUpperCase(),
        tags:Array.isArray(customer.tags) ? customer.tags : []
      };
    });

    (MTS.state.projects || []).forEach(project=>{
      const email = String(project.email || "").trim().toLowerCase() || "sans-email";
      if(!clients[email]){
        clients[email] = {
          id:"",
          key:`custom:${email}`,
          email,
          name:project.name || "Client",
          phone:project.phone || "",
          orderCount:0,
          projectCount:0,
          total:0,
          currency:"EUR",
          last:0,
          shopify:false,
          verifiedEmail:false,
          marketingState:"",
          tags:[]
        };
      }

      const client = clients[email];
      const comesFromShopify = project.source === "shopify_order" || project.shopifyOrderId;
      if(!comesFromShopify){
        client.projectCount++;
        client.total += Number(
          project.finalPrice ||
          project.quoteTotal ||
          project.quote?.total ||
          project.autoQuote?.quote?.suggested ||
          0
        );
      }
      client.last = Math.max(client.last, projectDate(project.updatedAt || project.createdAt));
      if(!client.phone && project.phone) client.phone = project.phone;
    });

    clientsList = Object.values(clients).sort((a,b)=>b.last-a.last);
    clientsList.forEach(client=>{ if(!client.key) client.key = `shopify:${client.id || client.email}`; });
    if(selectedClientKey && !clientsList.some(client=>client.key === selectedClientKey)) selectedClientKey = "";
    const errorHtml = loadError ? `<div class="mts-client-load-error"><strong>Clients Shopify indisponibles</strong><span>${MTS.escapeHtml(loadError)}</span><button type="button" class="mts-btn mts-soft" data-clients-retry>Reessayer</button></div>` : "";
    MTS.html("mtsClientsList", errorHtml + (clientsList.length ? clientsList.map(client=>`
      <button type="button" class="mts-crm-item ${selectedClientKey === client.key ? "active" : ""}" data-client-key="${MTS.escapeHtml(client.key)}">
        <strong>${MTS.escapeHtml(client.name)}${client.shopify ? " - Shopify" : ""}</strong>
        <span>
          ${MTS.escapeHtml(client.email || "E-mail non renseigne")}
          ${client.verifiedEmail ? " - e-mail verifie" : ""}
          ${client.marketingState === "SUBSCRIBED" ? " - e-mail marketing actif" : ""}
          ${client.phone ? `<br>${MTS.escapeHtml(client.phone)}` : ""}
          <br>${client.orderCount} commande(s) - ${client.projectCount} projet(s) sur mesure - ${money(client.total, client.currency)}
          ${client.tags.length ? `<br>${MTS.escapeHtml(client.tags.join(", "))}` : ""}
        </span>
      </button>
    `).join("") : `<div class="mts-empty">${loading ? "Chargement des clients Shopify..." : "Aucun client."}</div>`));
    renderDetail();
  }

  function renderDetail(message = "", messageType = ""){
    const client = clientsList.find(item=>item.key === selectedClientKey);
    if(!client){
      MTS.html("mtsClientDetail", `<div class="mts-empty">Selectionne un client pour consulter et modifier ses coordonnees.</div>`);
      return;
    }
    MTS.html("mtsClientDetail", `
      <form class="mts-client-edit" id="mtsClientEditForm" data-client-key="${MTS.escapeHtml(client.key)}">
        <div class="mts-client-edit-head">
          <div><h3>${MTS.escapeHtml(client.name)}</h3><p>Modifier les coordonnees du client.</p></div>
          <span class="mts-client-origin">${client.shopify ? "Client Shopify" : "Projet sur mesure"}</span>
        </div>
        <div class="mts-client-stats">
          <div><span>Commandes</span><strong>${client.orderCount}</strong></div>
          <div><span>Projets</span><strong>${client.projectCount}</strong></div>
          <div><span>Total</span><strong>${money(client.total, client.currency)}</strong></div>
        </div>
        <div class="mts-setting-grid">
          <label>Adresse e-mail<input type="email" id="mtsClientEmail" value="${MTS.escapeHtml(client.email === "sans-email" ? "" : client.email)}" required autocomplete="email"></label>
          <label>Numero de telephone<input type="tel" id="mtsClientPhone" value="${MTS.escapeHtml(client.phone || "")}" placeholder="+33..." autocomplete="tel"></label>
        </div>
        <div class="mts-client-message ${MTS.escapeHtml(messageType)}" id="mtsClientEditMessage">${MTS.escapeHtml(message)}</div>
        <div class="mts-actions"><button type="submit" class="mts-btn" ${saving ? "disabled" : ""}>${saving ? "Enregistrement..." : "Enregistrer les modifications"}</button></div>
      </form>`);
  }

  async function saveClient(event){
    event.preventDefault();
    if(saving) return;
    const client = clientsList.find(item=>item.key === selectedClientKey);
    if(!client) return;
    const email = String(document.getElementById("mtsClientEmail")?.value || "").trim().toLowerCase();
    const phone = String(document.getElementById("mtsClientPhone")?.value || "").trim();
    if(!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) return renderDetail("Adresse e-mail invalide.", "error");
    saving = true;
    renderDetail();
    try{
      if(client.shopify){
        const res = await fetch(`${API_BASE}/api/shopify/update-customer`, {
          method:"POST",
          headers:{"Content-Type":"application/json", accept:"application/json"},
          body:JSON.stringify({customerId:client.id, email, phone})
        });
        const data = await res.json().catch(()=>null);
        if(!res.ok || !data?.ok) throw new Error(data?.error || `Erreur Shopify ${res.status}`);
        await load(true);
      }else{
        const matching = (MTS.state.projects || []).filter(project=>String(project.email || "").trim().toLowerCase() === client.email);
        await Promise.all(matching.map(project=>MTS.state.db.collection("custom_requests").doc(project.id).set({email, phone, updatedAt:firebase.firestore.FieldValue.serverTimestamp()},{merge:true})));
        matching.forEach(project=>{ project.email = email; project.phone = phone; });
        selectedClientKey = `custom:${email}`;
        render();
      }
      renderDetail("Coordonnees enregistrees.", "success");
    }catch(err){
      renderDetail(err.message || "Impossible de modifier ce client.", "error");
    }finally{
      saving = false;
      renderDetail(document.getElementById("mtsClientEditMessage")?.textContent || "", document.getElementById("mtsClientEditMessage")?.classList.contains("error") ? "error" : "success");
    }
  }

  async function load(force = false){
    if(loading || (loaded && !force)) return;
    loading = true;
    loadError = "";
    render();

    try{
      const res = await fetch(`${API_BASE}/api/shopify/customers?first=100`, {
        headers:{accept:"application/json"},
        cache:"no-store"
      });
      const data = await res.json().catch(()=>null);
      if(!res.ok || !data?.ok) throw new Error(data?.error || `Erreur Shopify ${res.status}`);
      MTS.state.shopifyCustomers = data.customers || [];
      loaded = true;
    }catch(err){
      console.warn("Clients Shopify indisponibles :", err.message);
      loadError = err.message || "Connexion Shopify impossible.";
    }finally{
      loading = false;
      render();
    }
  }

  document.addEventListener("click", event=>{
    if(event.target.closest?.('.mts-nav button[data-panel="clients"]')) load(true);
    if(event.target.closest?.("[data-clients-retry]")) load(true);
    const clientButton = event.target.closest?.("[data-client-key]");
    if(clientButton && !clientButton.closest("#mtsClientEditForm")){
      selectedClientKey = clientButton.dataset.clientKey || "";
      render();
    }
  });
  document.addEventListener("submit", event=>{ if(event.target.id === "mtsClientEditForm") saveClient(event); });

  if(document.readyState === "loading"){
    document.addEventListener("DOMContentLoaded", ()=>setTimeout(()=>load(false), 1600));
  }else{
    setTimeout(()=>load(false), 1600);
  }

  MTS.ClientsShopify = {load, render};
})(window.MTS);


/* V20 hook dashboard */
(function(){
  function startV20Dashboard(){
    if(window.MTS && window.MTS.DashboardV20 && typeof window.MTS.DashboardV20.start === "function"){
      window.MTS.DashboardV20.start();
    }
  }
  if(document.readyState === "loading"){
    document.addEventListener("DOMContentLoaded", ()=>setTimeout(startV20Dashboard, 900));
  }else{
    setTimeout(startV20Dashboard, 900);
  }
})();


/* V21 hook paramètres */
(function(){
  function startSettings(){
    if(window.MTS && window.MTS.Settings && typeof window.MTS.Settings.start === "function"){
      window.MTS.Settings.start();
    }
  }
  if(document.readyState === "loading"){
    document.addEventListener("DOMContentLoaded", ()=>setTimeout(startSettings, 1200));
  }else{
    setTimeout(startSettings, 1200);
  }
})();

/* V23 hook commandes boutique */
(function(){
  function startOrders(){ if(window.MTS && window.MTS.Orders && typeof window.MTS.Orders.start === "function") window.MTS.Orders.start(); }
  if(document.readyState==="loading") document.addEventListener("DOMContentLoaded",()=>setTimeout(startOrders,900));
  else setTimeout(startOrders,900);
})();

/* V29 - Vignette Boutique : commandes payées à préparer */
(function(){
  const API_BASE = "https://bubbly-vibrancy-production.up.railway.app";
  let loading = false;

  function setBadge(count){
    const badge = document.getElementById("mtsShopNavCount");
    if(!badge) return;
    badge.textContent = String(count || 0);
    badge.hidden = !count;
  }

  async function refreshShopBadge(){
    if(loading) return;
    loading = true;
    try{
      const query = encodeURIComponent("financial_status:paid fulfillment_status:unfulfilled");
      const response = await fetch(`${API_BASE}/api/shopify/orders?first=100&query=${query}`, {
        headers:{accept:"application/json"},
        cache:"no-store"
      });
      const data = await response.json().catch(()=>null);
      if(!response.ok || !data?.ok) throw new Error(data?.error || `Erreur Shopify ${response.status}`);
      const count = (data.orders || []).filter(order=>{
        const financial = String(order.financialStatus || "").toUpperCase();
        const fulfillment = String(order.fulfillmentStatus || "").toUpperCase();
        return !order.cancelledAt && financial === "PAID" && fulfillment !== "FULFILLED";
      }).length;
      setBadge(count);
    }catch(error){
      console.warn("Vignette Boutique indisponible :", error.message);
    }finally{
      loading = false;
    }
  }

  document.addEventListener("click", event=>{
    if(event.target.closest?.('.mts-nav button[data-panel="shop"]')) refreshShopBadge();
    if(event.target.closest?.("#mtsRefreshOrders") || event.target.closest?.("#mtsRefresh")) {
      setTimeout(refreshShopBadge, 500);
    }
  });

  if(document.readyState === "loading"){
    document.addEventListener("DOMContentLoaded", ()=>setTimeout(refreshShopBadge, 1700));
  }else{
    setTimeout(refreshShopBadge, 1700);
  }

  window.MTS.ShopBadge = {refresh:refreshShopBadge};
})();
